import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ValuesTable from "../../components/values/ValuesTable";

const Values = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ValuesTable />
        </WrapperSection>
    );
};

export default Values;
